module.exports = __webpack_public_path__ + "img/bookmark_white_outline.ae94f1f6.png";